import { BlocksIconArrowForward } from 'blocks-nextjs/blocks-web-components/components/icon/icons/arrow-forward';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconArrowForward = createComponent({ react: React, tagName: 'cat-icon-arrow-forward', elementClass: BlocksIconArrowForward });
